import React, { useEffect, useState } from 'react';
import RecentArticle from '../RecentArticle/RecentArticle';
import { connect } from 'react-redux';
import Spinner from '../../UI/Spinner/Spinner'


const RecentPosts = (props) => {

    const [posts, setPosts] = useState(false)
    const [articlesToDisplay, setArticlesToDisplay] = useState(null)
    const [isLoading, setisLoading] = useState(true)
    const [error, seterror] = useState(null)

    useEffect(() => {
        setPosts(props.posts);

        if (props.error) {
            seterror(true)
            return;
        }
        //check if posts are already in localStorage
        if (typeof props.posts !== "undefined") {
            seterror(false)
            return;
        } else {
            setPosts(props.posts);
            seterror(false)
            return;
        }
    }, [props.posts])

    useEffect(() => {
        if (posts && posts.length > 0) {
            const posts_ = posts.slice(0, props.total);
            const articlesKeys = Object.keys(posts_);

            let articlesToShow = articlesKeys.map((key) => {
                const image = posts[key].img.src === "undefined" ? null : posts[key].img.src;
                /* change for prod */
                if (posts[key].post.published) {
                    return (
                        <RecentArticle
                            key={key}
                            img={image}
                            text={posts_[key].caption.title}
                            link={props.t('routes:blog.path') + '/' + posts[key].post.publishedLink + '?id=' + (posts[key].year + "-" + posts[key].monthDayTime)}
                            color="grey-medium-dark"
                        />
                    )
                }
                // return (
                //     <RecentArticle
                //         key={key}
                //         img={image}
                //         text={posts_[key].caption.title}
                //         link={props.t('routes:blog.path') + '/' + posts[key].post.publishedLink + '?id=' + (posts[key].year + "-" + posts[key].monthDayTime)}
                //         color="grey-medium-dark"
                //     />
                // )
            })
            setArticlesToDisplay(articlesToShow)
            setisLoading(false)
        }
    }, [posts])
    return (
        <>
            {isLoading ? < Spinner small /> : error ? <p>{props.t("blog:section1.errorPosts")}</p> : articlesToDisplay}
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        posts: state.posts.posts,
        error: state.posts.error
    }
}


export default connect(mapStateToProps)(RecentPosts)